import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import { LabelNew } from 'components/Shared/Scaffolding';
import { Icon } from 'components/Shared/Icon';
import { SCAFFOLDING, BUTTON_PRIMARY, TYPOGRAPHY, TRANSITION } from 'theme';

const StyledControl = styled.button`
    position: relative;
    width: ${SCAFFOLDING.GUTTER};
    height: 50px;
    padding: 0;
    border: 0;

    ${ifProp(
        'toggle',
        css`
            flex: 1 0 auto;
            background-color: ${SCAFFOLDING.BG};
            color: ${TYPOGRAPHY.LINK_COLOR.BASE};
        `,
        css`
            background-color: ${BUTTON_PRIMARY.BG.BASE};
            color: ${BUTTON_PRIMARY.COLOR.BASE};

            svg {
                height: 100%;
            }
        `
    )}

    ${ifProp(
        'active',
        `
        background-color: ${BUTTON_PRIMARY.BG.ACTIVE};
    `
    )}
`;

const StyledIcon = styled(Icon)`
    position: relative;
    z-index: 2;
    font-size: ${TYPOGRAPHY.FONT_SIZE.LARGE};
`;

const StyledLabel = styled.span`
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding-left: ${SCAFFOLDING.GUTTER};
    padding-right: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    z-index: 1;
    visibility: hidden;
    background-color: inherit;
    box-shadow: ${SCAFFOLDING.BOX_SHADOW.BASE};
    color: transparent;
    line-height: 50px;
    white-space: nowrap;
    transform: translate(-100%, 0);
    transition: all ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};

    button:hover &,
    button:focus & {
        visibility: visible;
        color: inherit;
        transform: translate(0, 0);
    }
`;

const StyledLabelNew = styled(LabelNew)`
    margin-left: 6px;
    opacity: 0;
    font-size: ${TYPOGRAPHY.FONT_SIZE.SMALL};
    font-weight: 700;
    transition: opacity ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};

    button:hover &,
    button:focus & {
        opacity: 1;
    }
`;

const SideControl = ({ glyph, title, newFeature, toggle, active, onClick }) => (
    <StyledControl toggle={toggle} active={active} onClick={onClick} aria-expanded="false">
        <StyledIcon glyph={glyph} />
        {title && (
            <StyledLabel>
                {title}
                {newFeature && <StyledLabelNew inverse>NEW</StyledLabelNew>}
            </StyledLabel>
        )}
    </StyledControl>
);

export default SideControl;
